import { talleres } from '@/content/site'
import styles from './Talleres.module.css'

export function Talleres() {
  return (
    <section id="charlas" className="section section--soft">
      <div className="container">
        <header className={`${styles.head} reveal`}>
          <p className="eyebrow">Charlas, talleres y capacitaciones</p>
          <h2 className="section-title">Ideas que movilizan. Experiencias que dejan algo después de terminar.</h2>
          <p className="section-lead">
            Charlas, talleres y capacitaciones orientadas al desarrollo de personas y equipos,
            combinando conocimiento, reflexión y herramientas aplicables a situaciones reales.
          </p>
        </header>

        <div className={styles.grid}>
          {talleres.map((t, i) => (
            <article key={t.title} className={`${styles.card} reveal`}>
              <span className={styles.num}>{String(i + 1).padStart(2, '0')}</span>
              <h3 className={styles.title}>{t.title}</h3>
              <p className={styles.text}>{t.text}</p>
            </article>
          ))}

          <article className={`${styles.custom} reveal`}>
            <h3 className={styles.customTitle}>Experiencias personalizadas</h3>
            <p className={styles.customText}>
              Cada organización es distinta. Podemos diseñar una charla, taller o experiencia de
              acuerdo con las necesidades y características de tu equipo.
            </p>
            <a href="#contacto" className="btn btn--primary btn--lg">
              Diseñemos una experiencia
            </a>
          </article>
        </div>
      </div>
    </section>
  )
}
